import { map, pipe, prop } from 'ramda'

// eslint-disable-next-line import/prefer-default-export
export const edgesNodesToList = pipe(prop(`edges`), map(prop(`node`)))
